// extracted by mini-css-extract-plugin
export default {"fullWidthDropdown":"fullwidth-dropdown_fullWidthDropdown__kZtL6"};